/**
 * Specifies how the calculation will be made.
 * tag: 2592
 * @readonly
 * @enum {number} (int)
 */
export enum CalculationMethod {
  Automatic = 0,
  Manual = 1,
}
